module.exports = __webpack_public_path__ + "static/media/notificationImage.6cabc438.jpg";